export default __webpack_public_path__ + "static/hp-brand-deck-12-8fa888b0d88f1186efc37206d256da3e.png";